import { Directive, model } from '@angular/core';
import { SortDirection, SortState } from './table.type';

const NEXT_DIRECTION: Record<SortDirection, SortDirection> = {
  '': 'asc',
  asc: 'desc',
  desc: '',
};

@Directive({
  selector: '[appSort]',
})
export class SortDirective {
  sort = model<SortState>({ active: '', direction: '' });

  directionOf(column: string): SortDirection {
    const { active, direction } = this.sort();

    return active === column ? direction : '';
  }

  toggle(column: string) {
    const direction = NEXT_DIRECTION[this.directionOf(column)];

    this.sort.set({ active: direction ? column : '', direction });
  }
}
